<template>
  <dialog-form
    :show-dialog="isShowDialog"
    :loading="loading"
    :is-disabled="!isValid"
    @open="dialogOpen"
    @cancel="emit('cancel')"
    @submit="submit"
  >
    <template #title>
      Settle dispute
    </template>

    <p class="text-muted mb-10">
      Reviewer's reason: {{ reason }}
    </p>

    <div class="row align-items-center">
      <label class="col-sm-4 control-label">Was this an error on the AI's side?*</label>
      <div class="col-sm-8">
        <dropdown-list
          v-model="wasAiError"
          :options="yesNoOptions"
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-4 control-label">Note*</label>
      <div class="col-sm-8">
        <sanitized-textarea
          v-model="note"
          allow-unicode
          :maxlength="MAX_TEXT_LENGTH"
          rows="4"
        />
      </div>
    </div>

    <p class="text-muted mb-0">
      The verdict is final once saved.
    </p>

    <template #submit-button>
      Settle
    </template>
  </dialog-form>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { yesNoOptions } from '@/constants/app';
import { YesNoEnum } from '@/models/app';

import { MAX_TEXT_LENGTH } from './qaCalibrations';

defineProps({
  isShowDialog: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  reason: {
    type: String,
    default: '',
  },
});

const emit = defineEmits<{
  (e: 'submit', value: { wasAiError: boolean; note: string }): void;
  (e: 'cancel'): void;
}>();

const wasAiError = ref<YesNoEnum | ''>('');
const note = ref('');

const isValid = computed(() => wasAiError.value !== '' && note.value.trim() !== '');

const dialogOpen = () => {
  wasAiError.value = '';
  note.value = '';
};

const submit = () => {
  emit('submit', { wasAiError: wasAiError.value === YesNoEnum.Yes, note: note.value.trim() });
};
</script>
